// Fornavne fra scripts/data/dictation-names.json — hold listerne synkroniserede.

import nameData from '../../scripts/data/dictation-names.json';

export function capitalizeDanishWord(word: string): string {
  if (word.length === 0) return word;
  const c = word.charAt(0);
  const upper =
    c === 'å' ? 'Å' : c === 'ø' ? 'Ø' : c === 'æ' ? 'Æ' : c.toUpperCase();
  return upper + word.slice(1);
}

/** Alle kuraterede fornavne (små bogstaver). */
export const DICTATION_FIRST_NAMES_LOWER: string[] = [
  ...nameData.boys,
  ...nameData.girls,
];

/** Fornavne med korrekt stort begyndelsesbogstav (til niveau 5+). */
export const DICTATION_FIRST_NAMES: string[] =
  DICTATION_FIRST_NAMES_LOWER.map(capitalizeDanishWord);
